import Command from '@ckeditor/ckeditor5-core/src/command';
import { CkeditorConstants, localService } from '../../src/utils';

const { COMMANDS: { CMD_TRACK_CHANGES },
  helperAttributes: { PARENT_CITATION },
  htmlAttributes: { ID },
  localStorageItem: { MARKED_AND_DELETED_CITATION }
} = CkeditorConstants

export default class DeleteCitationsCommand extends Command {
  execute({ value }) {
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    localService.remove(MARKED_AND_DELETED_CITATION);
    const foundItems = [...range.getItems({ ignoreElementEnd: true })].filter(item => (item.getAttribute?.(ID) === value.id || item.getAttribute?.(PARENT_CITATION) === value.id))

    const isEnabled = this.editor.commands.get(CMD_TRACK_CHANGES).value;
    const markedAndDeletedCitation = {
      marked: [],
      deleted: []
    }

    editor.model.change((writer) => {
      foundItems.forEach((item) => {
        const range = writer.createRangeOn(item);
        isEnabled ? this.editor.plugins.get('TrackChangesEditing').markDeletion(range) : writer.remove(range);
        const id = item._attrs.get('id');
        isEnabled ? markedAndDeletedCitation.marked.push(id) : markedAndDeletedCitation.deleted.push(id);
      });
    });
    localService.set(MARKED_AND_DELETED_CITATION, markedAndDeletedCitation);
  }
}
